/**
 * LocalizationContext
 * Tenant'ın JWT'deki LanguageCode claim'ine göre lokalizasyon verilerini yükler.
 * Login sonrası 'auth:login' custom event'i ile otomatik yenilenir.
 */

import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { getLanguageCode, getAuthHeaders } from '../utils/auth';

const LocalizationContext = createContext({ t: (key) => key, languageCode: 'tr-TR', isLoaded: false });

export function LocalizationProvider({ children }) {
  const [translations, setTranslations] = useState({});
  const [languageCode, setLanguageCode] = useState('tr-TR');
  const [isLoaded, setIsLoaded] = useState(false);

  const loadTranslations = useCallback(async () => {
    const code = getLanguageCode();
    try {
      const res = await fetch(`/api/Localization/Select`, {
        headers: getAuthHeaders(),
      });
      if (!res.ok) return;
      const data = await res.json();
      const map = {};
      data.forEach((item) => {
        const k = item.key ?? item.Key;
        const v = item.value ?? item.Value;
        if (k) map[k] = v;
      });
      setTranslations(map);
      setLanguageCode(code);
    } catch {
      // Hata durumunda anahtar key olduğu gibi görünür
    } finally {
      setIsLoaded(true);
    }
  }, []);

  useEffect(() => {
    // Uygulama ilk açıldığında yükle
    loadTranslations();

    // Login sonrası 'auth:login' event'i ile yenile
    window.addEventListener('auth:login', loadTranslations);
    return () => window.removeEventListener('auth:login', loadTranslations);
  }, [loadTranslations]);

  const t = useCallback((key, fallback) => translations[key] ?? fallback ?? key, [translations]);

  return (
    <LocalizationContext.Provider value={{ t, languageCode, isLoaded }}>
      {children}
    </LocalizationContext.Provider>
  );
}

export function useLocalization() {
  return useContext(LocalizationContext);
}
